const vehicles = {
  vehicles: 'Vehicles',

  headerButtons: {
    create: {
      createBtn: 'Create',
    },

    import: 'Import',
  },

  import: {
    title: 'Vehicles Upload',
  },

  toast: {
    error: {
      badResponse: '[Vehicle] bad server response',
      edit: {},
      create: {},
    },
    success: {
      edit: {
        resetSuccess: 'Successfully.',
      },
      create: {},
      delete: {
        default: '[Vehicle] deleted successfully',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      make: 'Make',
      model: 'Model',
      year: 'Year',
      color: 'Color',
      pax: 'Max Passengers',
      minSeats: 'Min Passengers',
      supplier: 'Suppliers',
      attributes: 'attributes',
      service: 'service'
    },
    filters: {
      supplier: 'Suppliers',
      attributes: 'Attributes',
      services: 'Services',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  deleteModal: {
    header: 'Delete Vehicles',
    body: 'You are about to delete {{num}} vehicles.',
  },

  create: {
    successToast: {
      message: 'Success! Vehicle Created!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Create Vehicle',
    },
  },

  edit: {
    successToast: {
      message: 'Success! Vehicle Updated!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Update Vehicle',
    },

    suspendButton: {
      actionActivate: 'Unsuspend',
      actionDeactivate: 'Suspend',
    },
    suspendModal: {
      popupTitleActive: 'Suspend Vehicle',
      popupTitleDeactivation: 'Unsuspend Vehicle',
      popupTitleUnsuspend: 'Unsuspend Reason',
      popupSubTitleDeactivation: 'Select the reason for the suspenssion',
      popupActionActive: 'Unsuspend Vehicle',
      popupActionDeactivate: 'Suspend Vehicle',
    },
    activeStatusButton: {
      statusActive: 'Active',
      statusDeactivate: 'Inactive',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Notes',
      historyTab: 'History',
      reservationPreferencesTab: 'Reservation Preferences',
    },
  },

  form: {
    header: {
      createVehicle: {
        title: 'Create',
      },

      updateVehicle: {
        title: 'Update',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },
    information: {
      details: {
        header: 'General Information',
        fields: {
          name: 'Name',
          site: 'Site',
          year: 'Year',
          location: 'Start Location',
          make: 'Make',
          model: 'Model',
          color: 'Color',
          suppliers: 'Suppliers',
          code: 'External ID',
          vin: 'VIN',
          productID: 'Product ID',
          licensePlate: 'License Plate',
          electric: 'Electric',
          connectorType: 'Connector Type',
          pricePerMinute: 'Cost Per Minute',
        },
      },
      attributes: {
        header: 'Attributes',
      },
      suppliers: {
        header: 'Suppliers',
        fields: {
          suppliers: 'Suppliers',
        },
      },
      mileageInspection: {
        header: 'Mileage & Inspection',
        fields: {
          mileage: 'Mileage',
          mileageLastInspection: 'Mileage in last inspection',
          lastInspectionDate: 'Last inspection Date',
          nextInspectionDate: 'Next inspection date',
        },
      },
      capacity: {
        header: 'Capacity',
        headerConfigurations: 'Capacity Configurations',
        fields: {
          seats: 'Max Seats',
          minSeats: 'Min Seats',
          attribute: 'Attribute',
          count: 'Count',
        },
        btnAddConfig: {
          title: 'Add Configuration',
        },
      },
      deliveriesDetails: {
        header: 'Deliveries Details',
        fields: {
          maxWeight: 'Max Weight',
          maxVolume: 'Max Volume',
        },
      },
      services: {
        header: 'Services',
      },
      insurance: {
        header: 'Insurance',
        fields: {
          typeOfInsurance1: 'Type of insurance 1',
          typeOfInsurance1_start: 'Start date',
          typeOfInsurance1_end: 'End date',
          typeOfInsurance2: 'Type of insurance 2',
          typeOfInsurance2_start: 'Start date',
          typeOfInsurance2_end: 'End date',
        },
      },
      dimensions: {
        header: 'Vehicle Dimensions',
      },
      getProductBtn: 'SHOW GETT product IDs',
      excludedProfiles: {
        header: 'Excluded Profiles',
        dualList: {
          profilesList: {
            header: 'Profile List',
          },
          excludedList: {
            header: 'Excluded Profiles',
          },
        },
      },
    },
    valdations: {
      name: 'Name is required',
      plateNumber: {
        matches: 'Max Passengers must be a number',
        required: 'Max Passengers is Required',
      },
      service: 'Service With is required',
      pax: {
        matches: 'Pax must be a number',
        required: 'Pax is Required',
      },
      minSeats: {
        matches: 'Min Seats must be a number',
        required: 'Min Seats is Required',
      },
      model: 'Model With is required',
      color: 'Color With is required',
      year: {
        matches: 'Year must be a number',
        required: 'Year is Required',
      },
      licenseExpDate: 'License Expiration is required',
    },
  },

  statuses: {
    online: 'Online',
    suspended: 'Suspended',
    onATrip: 'On A Trip',
  },

  totalVehicles: 'Total Vehicles',
};

export default vehicles;
